import React, { useEffect, useState } from 'react'

import { IconButton, InputAdornment,TextField } from '@mui/material';
import { FaHome } from 'react-icons/fa';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

import { AiOutlineSetting, AiOutlineGlobal, AiOutlineHdd, AiOutlineMenu, AiOutlineSearch, AiTwotoneShop, AiOutlineSolution, AiOutlineLaptop, AiOutlineSend, AiFillDatabase } from "react-icons/ai";
//import logo from '../../images/newlogo.png'
import logo from '../img/newlogo.png'

import RightMenu from './comon/RightMenu';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import Home from './Home';
import Rolemaster from './Rolemaster';
import SubscriptionMaster from './SubscriptionMaster';
import Invite from './Invite';
import Individual from './Individual';
import Business from './Business';
import RolemasterList from './RolemasterList';
import SubscriptionMasterList from './SubscriptionMasterList';
import InviteList from './InviteList';
import TreasuryList from './TreasuryList';
import TreasuryNew from './TreasuryNew';
import TimePeriod from './TimePeriod';
import BusinessList from './BusinessList';
import Addform from './Addform';
import CommunityQuestions from './CommunityQuestions';
import CommunityList from './CommunityList';
import FeedbackList from './FeedbackList';
import AmbassadorList from './AmbassadorList';
import TokenRegistorList from './TokenRegistorList';
import SubscriptionEmailList from './SubscriptionEmailList';
import AddNews from './AddNews';




function Dashboard() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState(null);

    const handleDrawerToggle = () => {
        setOpen(!open);
    };
    useEffect(() => {
        const userData = localStorage.getItem('user');
        console.log(JSON.parse(userData))
        if (userData === null) {
            navigate('/login')
        } else {
            setUser(JSON.parse(userData));
        }
    }, [])
    return (
        <div style={{ display: 'flex' }}>
            {/* backgroundColor="#673ab7" */}
            <Sidebar style={{ height: '700px' }} className="custom-sidebar" toggled={open}>
                <div className='dashboard'>
                    <img src={logo} alt="logo" className='logo' />
                </div>
                {user?.level === 1 ? (
                    <>
                        <Menu>
                            <MenuItem component={<Link to="/dashboard" />} icon={<FaHome />}> Dashboard </MenuItem>
                            <MenuItem component={<Link to="/dashboard/time-period" />} icon={<AiOutlineHdd />}>Set time period  </MenuItem>
                            <MenuItem component={<Link to="/dashboard/community-questions" />} icon={<AiOutlineHdd />}>Set Community questions  </MenuItem>
                            <SubMenu label="Community" icon={<AiOutlineLaptop />}>
                                <MenuItem component={<Link to="/dashboard/community-list" />} icon={<AiOutlineSolution />} > Community </MenuItem>
                                <MenuItem component={<Link to="/dashboard/feedback-list" />} icon={<AiTwotoneShop />} > Feedback </MenuItem>
                            </SubMenu>
                            <MenuItem component={<Link to="/dashboard/add-news" />} icon={<AiOutlineHdd />}>News Add </MenuItem>
                            <MenuItem component={<Link to="/dashboard/ambassador-list" />} icon={<AiOutlineHdd />}>Ambassador </MenuItem>
                            <MenuItem component={<Link to="/dashboard/token-registration-list" />} icon={<AiOutlineHdd />}>Token registration list </MenuItem>
                            <MenuItem component={<Link to="/dashboard/add-form" />} icon={<AiOutlineHdd />}>Add form </MenuItem>
                            <MenuItem component={<Link to="/dashboard/rolemaster" />} icon={<AiOutlineHdd />}>User Category Role Master </MenuItem>
                            <MenuItem component={<Link to="/dashboard/subscription-master-list" />} icon={<AiOutlineSetting />}> Subscription Master </MenuItem>
                            <MenuItem component={<Link to="/dashboard/invite-list" />} icon={<AiOutlineSend />} > Invite </MenuItem>
                            <MenuItem component={<Link to="/dashboard/treasury-list" />} icon={<AiFillDatabase />} > Treasury </MenuItem>
                            <MenuItem component={<Link to="/dashboard/subscription-email" />} icon={<AiFillDatabase />} >Subscription Email List </MenuItem>
                            {/* shareholder registration */}
                            <SubMenu label="Shareholder registration" icon={<AiOutlineLaptop />}>
                                <MenuItem component={<Link to="/dashboard/individual" />} icon={<AiOutlineSolution />} > Individual </MenuItem>
                                <MenuItem component={<Link to="/dashboard/business" />} icon={<AiTwotoneShop />} > Business </MenuItem>
                                <MenuItem component={<Link to="/dashboard/business-list" />} icon={<AiTwotoneShop />} > Business </MenuItem>
                            </SubMenu>
                            <MenuItem icon={<AiOutlineGlobal />}> Reports & Graphs </MenuItem>
                        </Menu>
                    </>
                ) : (
                    <>
                        <Menu>
                            <MenuItem component={<Link to="/dashboard" />} icon={<FaHome />}> Dashboard </MenuItem>
                            <MenuItem component={<Link to="/dashboard/rolemaster" />} icon={<AiOutlineHdd />}> User role master </MenuItem>
                            <MenuItem component={<Link to="/dashboard/subscription-master" />} icon={<AiOutlineSetting />}> Subscription Master </MenuItem>
                            <MenuItem component={<Link to="/dashboard/invite" />} icon={<AiOutlineSend />} > Invite </MenuItem>
                            <MenuItem component={<Link to="/dashboard/treasury-list" />} icon={<AiFillDatabase />} > Treasury </MenuItem>
                            {/* shareholder registration */}
                            <SubMenu label="Shareholder registration" icon={<AiOutlineLaptop />}>
                                <MenuItem component={<Link to="/dashboard/individual" />} icon={<AiOutlineSolution />} > Individual </MenuItem>
                                <MenuItem component={<Link to="/dashboard/business" />} icon={<AiTwotoneShop />} > Business </MenuItem>
                            </SubMenu>
                            <MenuItem icon={<AiOutlineGlobal />}> Reports & Graphs </MenuItem>
                        </Menu>
                    </>
                )}


            </Sidebar>
            <div className='right'>
                <div className='in-hdr'>
                    <div>

                        <IconButton size="large" onClick={handleDrawerToggle}>
                            <AiOutlineMenu />
                        </IconButton>
                        <TextField
                            label="Search.."
                            id="outlined-start-adornment"
                            sx={{ m: 1 }}
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <AiOutlineSearch />
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </div>

                    <RightMenu />
                </div>
                <Routes>
                    <Route path='/' element={<Home />}></Route>
                    <Route path='/time-period' element={<TimePeriod />}></Route>
                    <Route path='/add-form' element={<Addform />}></Route>
                    <Route path='/community-questions' element={<CommunityQuestions />}></Route>
                    <Route path='/community-list' element={<CommunityList />}></Route>
                    <Route path='/feedback-list' element={<FeedbackList />}></Route>
                    <Route path='/ambassador-list' element={<AmbassadorList />}></Route>
                    <Route path='/token-registration-list' element={<TokenRegistorList />}></Route>
                    <Route path='/subscription-email' element={<SubscriptionEmailList />}></Route>
                    <Route path='/add-news' element={<AddNews />}></Route>

                    <Route path='/rolemaster' element={<Rolemaster />}></Route>
                    <Route path='/rolemaster-list' element={<RolemasterList />}></Route>
                    <Route path='/subscription-master' element={<SubscriptionMaster />}></Route>
                    <Route path='/subscription-master-list' element={<SubscriptionMasterList />}></Route>
                    <Route path='/invite' element={<Invite />}></Route>
                    <Route path='/invite-list' element={<InviteList />}></Route>
                    <Route path='/individual' element={<Individual />}></Route>
                    <Route path='/business' element={<Business />}></Route>
                    <Route path='/business-list' element={<BusinessList />}></Route>
                    <Route path='/treasury-add' element={<TreasuryNew />}></Route>
                    <Route path='/treasury-list' element={<TreasuryList />}></Route>
                </Routes>


            </div>
        </div>
    )
}

export default Dashboard